import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDecreaseBadge = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.82237 12.4516L5.70036 16.446H16.5004V5.98036L12.3784 9.97474L4.65452 2.50192C6.68444 0.933557 9.23285 0 12 0C18.6274 0 24 5.35499 24 11.9607C24 18.5664 18.6274 23.9214 12 23.9214C5.37259 23.9214 0 18.5664 0 11.9607C0 9.39127 0.81287 7.01107 2.19627 5.06163L9.82237 12.4516Z",
		fill: "#DB6F40"
	})
});
export default SvgDecreaseBadge;
